module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpY29uLW5hdGlvbmFscGFyay1hMjE3ZDFmMTAyM2QwZGQ0MjljN2IwOTk2ODlkMmMwZi5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/icon-nationalpark.svg
// module id = 576
// module chunks = 0